import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormAlertModule, SimpleModalModule } from '@com-delta-idp/mnx-ui-kit';
import { ViewModalComponent } from './view-modal.component';
@NgModule({
  declarations: [ViewModalComponent],
  imports: [CommonModule, SimpleModalModule, FormAlertModule],
  exports: [ViewModalComponent]
})
export class ViewModalModule {}
